//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "goodInfo",
  data() {
    return {
      goodsDetail: {}
    }
  },
  props: {
    goodsData: {
      type: Object,
      default: {}
    },
  },
  created() {
    console.log('能不能拿到??', this.goodsData);
    this.goodsDetail = JSON.parse(JSON.stringify(this.goodsData));
  },
  mounted() {
    // ;
  },
  methods: {

  },
}



// WEBPACK FOOTER //
// ./src/component/goodInfo/index.vue